<template>
  <div>
    <v-row>
      <v-col cols="12" class="pt-5 pt-md-9 pb-2 pb-md-5">
        <router-link :to="{ name: 'domains' }">
          <v-icon size="20">mdi-keyboard-backspace</v-icon>
          Back to Domains
        </router-link>

        <!-- <gg-btn
          v-if="domainTransferViewResponse.invoice_id"
          outlined
          class="ml-4"
          @click="showReceipt"
        >
          View Receipt
        </gg-btn> -->
      </v-col>
      <v-col cols="12" class="pt-0">
        <gg-card>
          <gg-card-header>
            <v-row>
              <v-col cols="6" md="4">
                View Domain Transfer Request
              </v-col>
              <v-col  cols="6" md="8" class="text-right">
                <gg-btn v-if="canBeRestarted" class="mx-1" right @click="openModalRestart">Restart</gg-btn>
                <gg-btn v-if="canBeCanceled" class="mx-1" secondary right @click="openModalCancel">Cancel</gg-btn>
              </v-col>
            </v-row>
          </gg-card-header>
          <gg-card-text>
            <v-data-table :headers="headers" :items="items" hide-default-footer :loading="loading">
              <template v-slot:item.status="{ item }">
                <v-icon small class="mb-1" :color="statusColor(item.status)">
                  mdi-circle
                </v-icon>
                {{ item.status | capitalize }}
              </template>
              <template v-slot:item.price="{ item }">
                {{ parseFloat(item.price).toFixed(2) }} USD
              </template>
            </v-data-table>
          </gg-card-text>
        </gg-card>
      </v-col>
    </v-row>
    <v-row v-if="showPayOption">
      <v-col>
        <gg-card>
          <gg-card-header>
            <v-row>
              <v-col cols="12">
                Domain Transfer Payment
              </v-col>
            </v-row>
          </gg-card-header>
          <gg-card-text>
            <template v-if="showTabs">
              <v-tabs v-model="tab" flat background-color="transparent" class="mb-0">
                <v-tabs-slider color="green"></v-tabs-slider>
                <v-tab key="payment" exact>
                  Paid Transfer
                </v-tab>
                <v-tab key="free">
                  Free Transfer
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <payment-gateway
                    compact
                    ref="paymentGateway"
                    @gateway="listenGateway"
                    @card="listenCard"
                    @card-switch="listenCardNew"
                    @close="closeModal"
                  >
                    <template v-slot:header>Domain Transfer Payment</template>
                    <template v-slot:actions>
                      <v-row>
                        <v-col cols="12">
                          <gg-btn secondary @click="closeModal" class="mr-4 ml-2">
                            Cancel
                          </gg-btn>
                          <gg-btn primary :loading="payment_loading" @click="makePayment">
                            Pay with a credit card
                          </gg-btn>
                        </v-col>
                      </v-row>
                    </template>
                  </payment-gateway>
                </v-tab-item>
                <v-tab-item>
                  <gg-card-text>
                    <v-row>
                      <v-col cols="12">
                        You have a free domain transfer available. Select a service to redeem your free transfer against.
                      </v-col>
                      <v-col cols="6" md="6" sm="12">
                        <gg-select
                          dense
                          outlined
                          label="Select Service for Free Transfer:"
                          v-model="freeMigrationService"
                          :items="freeMigrationServices"
                          item-value="id"
                          hide-details
                        >
                          <template slot="selection" slot-scope="{ item }">
                            {{ item.groupname }} - {{ item.domain }}
                          </template>
                          <template slot="item" slot-scope="{ item }">
                            {{ item.groupname }} - {{ item.domain }}
                          </template>
                        </gg-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="pb-4 pr-4">
                        <gg-btn primary :disabled="!freeMigrationService" :loading="payment_loading" @click="makeFreeTransfer">
                          Redeem Free Transfer
                        </gg-btn>
                      </v-col>
                    </v-row>
                  </gg-card-text>
                </v-tab-item>
              </v-tabs-items>
            </template>
            <template v-else>
              <payment-gateway
                compact
                ref="paymentGateway"
                @gateway="listenGateway"
                @card="listenCard"
                @card-switch="listenCardNew"
                @close="closeModal"
              >
                <template v-slot:header>Domain Transfer Payment</template>
                <template v-slot:actions>
                  <gg-btn secondary @click="closeModal">
                    Cancel
                  </gg-btn>
                  <gg-btn primary :loading="payment_loading" @click="makePayment">
                    Pay with a credit card
                  </gg-btn>
                </template>
              </payment-gateway>
            </template>
          </gg-card-text>
        </gg-card>
      </v-col>
    </v-row>
    <gg-modal :is-active="modalRestart" @close="closeModalRestart">
      <template v-slot:toolbar>
        Restart Transfer
      </template>
      <template v-slot:body>
        <p>You are about to restart the domain transfer attempt. Please make sure you have addressed the reason for the failure before restarting the transfer.</p>
        <p>If you need to provide us with a new EPP code, you may enter it below.</p>
        <p><v-col cols="12" sm="12" class="py-0">
          <gg-text-field
            v-model="eppCode"
            aria-label="Epp Code"
            name="EppCode"
            outlined
            placeholder="Epp Code"
          />
        </v-col></p>
        <p>Are you sure you want to proceed?</p>
      </template>
      <template v-slot:actions>
        <gg-btn secondary @click="closeModalRestart">
          No
        </gg-btn>
        <gg-btn primary @click="proceedRestartTransfer" :loading="modalProceedLoading">
          Yes
        </gg-btn>
      </template>
    </gg-modal>
    <gg-modal :is-active="modalCancel" @close="closeModalCancel">
      <template v-slot:toolbar>
        Cancel Transfer
      </template>
      <template v-slot:body>
        <p>You are about to cancel this domain transfer request.</p>
        <p>Are you sure you want to proceed?</p>
      </template>
      <template v-slot:actions>
        <gg-btn secondary @click="closeModalCancel">
          No
        </gg-btn>
        <gg-btn primary @click="proceedCancelTransfer" :loading="modalProceedLoading">
          Yes
        </gg-btn>
      </template>
    </gg-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { statusColor } from '@/helpers/helpers'
import PaymentGateway from '@/components/Common/PaymentGateway'

export default {
  name: 'DomainTransferRequestView',

  components: {
    PaymentGateway,
  },

  data: () => {
    return {
      loading: true,
      headers: [
        {
          text: 'Domain',
          value: 'domain',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false,
        },
        // {
        //   text: 'Price',
        //   value: 'price',
        //   sortable: false,
        // },
        {
          text: 'Registrar Status',
          value: 'registrar_transfer_status',
          sortable: false,
        },
        {
          text: 'Created',
          value: 'created_at',
          sortable: false,
        },
      ],
      items: [],
      showModal: false,
      gateway: '',
      isCardNew: false,
      model: {
        cardnum: '',
        cardnum_cvv: '',
        expdate: ''
      },
      payment_loading: false,
      domainTransferViewResponse: {},
      modalRestart: false,
      modalCancel: false,
      modalProceedLoading: false,
      eppCode: null,
      tab: 'payment',
      freeMigrationService: '',
      freeMigrationServices: [],
    }
  },

  computed: {
    ...mapGetters(['getDomainsTransferList', 'services']),
    showPayOption () {
      return this.items.at(0)?.status === 'payment'
    },
    canBeRestarted () {
      return this.items.at(0)?.status === 'failed'
    },
    canBeCanceled () {
      return this.items.at(0)?.can_be_cancelled
    },
    showTabs () {
      return !!this.domainTransferViewResponse?.free_domain_service_ids.length
    }
  },
  methods: {
    ...mapActions({
      domainTransferPay: 'billing/domainTransferPay',
      fetchDomainTransferView: 'fetchDomainTransferView',
      reportError: 'reportError',
      reportSuccess: 'reportSuccess',
      postDomainTransferRestart: 'postDomainTransferRestart',
      postDomainTransferCancel: 'postDomainTransferCancel',
    }),
    statusColor,
    async getData () {
      try {
        this.items = []
        this.loading = true
        const id = this.getDomainTransferId()
        this.domainTransferViewResponse = await this.fetchDomainTransferView({ id })
        this.items.push(this.domainTransferViewResponse)
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    getDomainTransferId () {
      return parseInt(this.$route.params.domainTransferId)
    },
    listenGateway (gateway) {
      this.gateway = gateway
    },
    listenCard (card) {
      this.model = card
    },
    listenCardNew (card) {
      this.isCardNew = card
    },
    openModal () {
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
    },
    async makePayment () {
      const valid = await this.$refs.paymentGateway.validateForm()
      if (!valid) return
      try {
        switch (this.gateway) {
          case 'credit_card':
            await this.handleCreditCardPayment()
            break
        }
        this.closeModal()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.payment_loading = false
      }
    },
    async handleCreditCardPayment () {
      this.payment_loading = true
      const data = {
        id: this.getDomainTransferId(),
        method: 'creditcard',
        cvv: this.payment_cvv,
        cc: 'primary',
        cardnum: this.isCardNew ? this.model.cardnum : '',
        expdate: this.isCardNew ? this.model.expdate : '',
        cardnum_cvv: this.model.cardnum_cvv
      }
      const response = await this.domainTransferPay(data)
      if (response.result === 'success') {
        this.payment_loading = false
        this.reportSuccess('Payment Approved')
        this.getData()
      } else {
        this.payment_loading = false
        this.reportError('Payment Declined')
      }
    },
    openModalRestart () {
      this.modalRestart = true
    },
    openModalCancel () {
      this.modalCancel = true
    },
    closeModalRestart () {
      this.modalRestart = false
    },
    closeModalCancel () {
      this.modalCancel = false
    },
    async proceedRestartTransfer () {
      this.modalProceedLoading = true
      try {
        const data = {
          id: this.getDomainTransferId()
        }
        if (this.eppCode) {
          data.epp_code = this.eppCode
        }
        await this.postDomainTransferRestart(data)
        await this.getData()
      } catch (e) {
      } finally {
        this.modalProceedLoading = false
        this.closeModalRestart()
      }
    },
    async proceedCancelTransfer () {
      this.modalProceedLoading = true
      try {
        const data = {
          id: this.getDomainTransferId()
        }
        await this.postDomainTransferCancel(data)
        await this.getData()
      } catch (e) {
      } finally {
        this.modalProceedLoading = false
        this.closeModalCancel()
      }
    },
    setFreeMigrationServices () {
      if (!this.domainTransferViewResponse?.free_domain_service_ids.length) {
        return
      }
      this.freeMigrationServices = this.services.filter((service) => {
        return this.domainTransferViewResponse.free_domain_service_ids.includes(parseInt(service.id))
      })
    },
    async makeFreeTransfer () {
      if (!this.freeMigrationService) {
        return
      }
      this.payment_loading = true
      const data = {
        id: this.getDomainTransferId(),
        free_domain_service_id: this.freeMigrationService,
      }
      const response = await this.domainTransferPay(data)
      if (response.result === 'success') {
        this.payment_loading = false
        this.reportSuccess('Free Transfer Approved')
        this.getData()
      } else {
        this.payment_loading = false
        this.reportError('Free Transfer Declined')
      }
    },
    showReceipt () {
      window.open(`/billing/${this.domainTransferViewResponse.invoice_id}`, '', 'width=600, height=900')
    }
  },

  async mounted () {
    await this.getData()
    this.setFreeMigrationServices()
  },

  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
}
</script>

<style scoped>
</style>
